/**
 * Single-step validation for expert contact form.
 */
import {
  getEmailError,
  getNameError,
  getPhoneError,
  normalizeWhitespace,
} from '../utils/validation'
import type { FormState } from './useContactFormState'
import type { SupportedLocale } from '../types'

export function useContactFormValidation(
  form: { value: FormState },
  errors: { value: Partial<Record<keyof FormState, string>> },
  t: (key: string) => string,
  setError: (key: keyof FormState, msg: string) => void,
  shake: () => void,
  locale?: { value: SupportedLocale | string }
) {
  function validate(): boolean {
    let ok = true
    const first = normalizeWhitespace(form.value.firstName)
    const emailKey = getEmailError(form.value.email)
    if (emailKey) {
      setError('email', t(`errors.${emailKey}`))
      ok = false
    }
    const firstKey = getNameError(first)
    if (firstKey) {
      setError('firstName', t(`errors.${firstKey}`))
      ok = false
    }
    const phoneKey = getPhoneError(form.value.phone.trim(), {
      requireCountryCode: locale?.value === 'en',
    })
    if (phoneKey) {
      setError('phone', t(`errors.${phoneKey}`))
      ok = false
    }
    if (!form.value.budget) {
      setError('budget', t('errors.select_budget'))
      ok = false
    }
    if (!form.value.timeline) {
      setError('timeline', t('errors.select_timeline'))
      ok = false
    }
    if (!ok) shake()
    return ok
  }

  return { validate }
}
